import React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Label } from "@whatslly/ui-components/v2/BaseElements/Label";
import { TextInputWithCopy } from "@whatslly/ui-components/v2/TextInputWithCopy";
import styles from "../../modals/Modals.module.scss";
import { SwitchField } from "../SwitchField";

const generateDek = async (): Promise<string> => {
  const key = await crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, true, ["encrypt", "decrypt"]);
  const raw = new Uint8Array(await crypto.subtle.exportKey("raw", key));
  return btoa(String.fromCharCode(...raw));
};

export const EncryptionKeyField: React.FC<{ locked: boolean }> = ({ locked }) => {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<{ dek?: string; lake?: boolean }>();
  const lake = Boolean(values.lake);

  return (
    <>
      <SwitchField
        label={t("destinations_page.client_encryption")}
        testId="encryption-switch"
        disabled={locked || lake}
        disabledReason={lake ? t("destinations_page.lake.encryption_conflict") : undefined}
        checked={Boolean(values.dek)}
        onChange={async (on) => setFieldValue("dek", on ? await generateDek() : "")}
      />
      {!locked && values.dek && (
        <div className={styles.field}>
          <Label className={styles.filedLabel} text={t("destinations_page.client_encryption_key")} />
          <TextInputWithCopy type="password" value={values.dek} disabled={true} />
        </div>
      )}
    </>
  );
};
